import React from 'react';
import { observer } from 'mobx-react-lite';
import LanguageSwitcher from './LanguageSwitcher';
import SystemStatus from './SystemStatus';
import { collectionNavStore } from '../store/collectionNavStore';
import { bookmarkNavStore } from '../store/bookmarkNavStore';
import { isLocalGateway } from '../services/api';
import './NavBar.css';

interface NavBarProps {
  currentHash: string;
}

const NavBar: React.FC<NavBarProps> = observer(({ currentHash }) => {
  const isLibrary   = currentHash === '#library';
  const isBookmarks = currentHash === '#bookmarks';
  const isBattle    = currentHash === '#battle';
  const isAdmin     = currentHash === '#admin';
  const isPlay      = !isLibrary && !isBookmarks && !isBattle && !isAdmin;

  const handleGameClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.hash = '';
  };

  const handleLibraryClick = (e: React.MouseEvent) => {
    e.preventDefault();
    collectionNavStore.clear();
    bookmarkNavStore.clear();
    window.location.hash = '#library';
  };

  const handleBookmarksClick = (e: React.MouseEvent) => {
    e.preventDefault();
    collectionNavStore.clear();
    bookmarkNavStore.clear();
    window.location.hash = '#bookmarks';
  };

  return (
    <nav className="app-nav">
      <span className="app-nav-logo">DeepGo</span>
      <div className="app-nav-links">
        <a href="#" onClick={handleGameClick} className={`app-nav-link${isPlay ? ' active' : ''}`}>
          Play
        </a>
        <a href="#library" onClick={handleLibraryClick} className={`app-nav-link${isLibrary ? ' active' : ''}`}>
          Library
        </a>
        <a href="#bookmarks" onClick={handleBookmarksClick} className={`app-nav-link${isBookmarks ? ' active' : ''}`}>
          Bookmarks
        </a>
        {isLocalGateway && (
          <a href="#battle" onClick={e => { e.preventDefault(); window.location.hash = '#battle'; }}
            className={`app-nav-link${isBattle ? ' active' : ''}`}>
            Battle
          </a>
        )}
        {isLocalGateway && (
          <a href="#admin" onClick={e => { e.preventDefault(); window.location.hash = '#admin'; }}
            className={`app-nav-link${isAdmin ? ' active' : ''}`}>
            Admin
          </a>
        )}
      </div>
      <div className="app-nav-right">
        <SystemStatus />
        <LanguageSwitcher />
      </div>
    </nav>
  );
});

export default NavBar;
